"use client";

import { useTranslations } from "next-intl";

function Corner({ className = "" }: { className?: string }) {
	return (
		<svg
			aria-hidden
			viewBox="0 0 12 12"
			className={`text-primary/40 absolute h-3 w-3 ${className}`}
			fill="none"
			stroke="currentColor"
			strokeWidth="1"
		>
			<path d="M0 4 V0 H4" />
		</svg>
	);
}

interface PeptideImagePlaceholderProps {
	code: string;
	className?: string;
}

export function PeptideImagePlaceholder({ code, className = "" }: PeptideImagePlaceholderProps) {
	const t = useTranslations("catalog.peptideImage");

	return (
		<div
			className={`relative overflow-hidden bg-background ${className}`}
			aria-label={`${code} · ${t("placeholderAria")}`}
		>
			<div
				aria-hidden
				className="absolute inset-0 opacity-[0.06]"
				style={{
					backgroundImage:
						"linear-gradient(to right, var(--primary) 1px, transparent 1px), linear-gradient(to bottom, var(--primary) 1px, transparent 1px)",
					backgroundSize: "32px 32px",
				}}
			/>
			<Corner className="left-2 top-2" />
			<Corner className="right-2 top-2 rotate-90" />
			<Corner className="bottom-2 left-2 -rotate-90" />
			<Corner className="bottom-2 right-2 rotate-180" />
			<div className="absolute inset-0 flex flex-col items-center justify-center px-4 text-center">
				<div className="text-primary/70 font-mono text-[0.65rem] uppercase tracking-[0.22em]">{code}</div>
				<div className="mt-1 font-mono text-[0.58rem] uppercase tracking-[0.18em] text-muted-foreground">
					{t("placeholderLabel")}
				</div>
			</div>
		</div>
	);
}
